module.exports = __webpack_public_path__ + "img/wood-block--finished.svg";